var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winnicott-loading-container"},[_c('div',{staticClass:"winnicott-loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_c('p',[_vm._v("Aguarde...")]),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }